(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.credit-v2.pdf.view
  (:require
   [frontend.ui.component.lp-portal.card.pdf.view :as card]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.details-and-figures :as
    pe-view-details-and-figures]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.investors :as
    pe-view-investors]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.overview :as
    pe-view-overview]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.tearsheet :as
    pe-view-tearsheet]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.style.theme.core :as theme]
   [ui.components.rich-text.tiptap :as tiptap]))

(defn- rich-text-present?
  [{:keys [rich-content]}]
  (not (tiptap/empty-editor-value? rich-content)))

(defn esg-key-performance-indicators
  [esg]
  (let [key-perf-indicators (:figures esg)
        labels (cons nil (:column-order key-perf-indicators))
        rows (if (map? (:data key-perf-indicators)) ;;To make sure old data model still works
               (->> key-perf-indicators
                    :data
                    (mapv (fn [[row-label row-data]]
                            (cons row-label
                                  (->> (:column-order key-perf-indicators)
                                       (mapv (fn [k]
                                               (get row-data k))))))))
               (:data key-perf-indicators))
        data (cons labels rows)]
    (card/card
     "Key Performance Indicators"
     (table/raw-table data)
     (text-content/optional-footer esg {:margin-top 6}))))

(defn esg-page-1
  [report-data]
  (let [{:keys [esg-targets-and-strategy-text key-perf-indicators]} (:esg report-data)]
    (page/page
     (page/page-title {:fund-name (:fund-name report-data) :page-title "Sustainability" :toc-item true})
     (column/column
      (card/card
       "Sustainability targets and strategy"
       (text-content/rich-content (:rich-content esg-targets-and-strategy-text)))
      (esg-key-performance-indicators key-perf-indicators)))))

(defn esg-pages
  [report-data]
  [(esg-page-1 report-data)])

(defn capital-account-since-inception-pages
  [report-data]
  (table/dynamic-table-pages
   {:fund-name (:fund-name report-data) :page-title "Capital account" :toc-item true}
   "Capital account since inception, €"
   (->> report-data
        :capital-account-since-inception)
   {:partition-size   20
    :full-width?      true
    :skip-title-cell? true
    :odd-color        (theme/color [:pdf :table :odd-color])
    :even-color       (theme/color [:pdf :table :even-color])
    :heading-color    (theme/color [:pdf :table
                                    :heading-color])}))

(defn capital-account-year-to-date-pages
  [report-data]
  (table/dynamic-table-pages
   {:fund-name (:fund-name report-data) :page-title "Capital account"}
   "Capital account year to date, €"
   (->> report-data
        :capital-account-year-to-date)
   {:partition-size   20
    :full-width?      true
    :skip-title-cell? true
    :odd-color        (theme/color [:pdf :table :odd-color])
    :even-color       (theme/color [:pdf :table :even-color])
    :heading-color    (theme/color [:pdf :table
                                    :heading-color])}))

(defn fees-and-carried-interest-pages
  [report-data]
  (table/dynamic-table-pages {:fund-name (:fund-name report-data) :page-title "Fees" :toc-item true}
                             "Fees and carried interest, €"
                             (->> report-data
                                  :fees-and-carried-interest)
                             {:skip-title-cell? true
                              :odd-color        (theme/color [:pdf :table :odd-color])
                              :even-color       (theme/color [:pdf :table :even-color])
                              :heading-color    (theme/color [:pdf :table
                                                              :heading-color])}))

(defn- market-outlook-page
  [report-data market-outlook title toc-item?]
  (page/page
   (page/page-title {:fund-name (:fund-name report-data)
                     :page-title "Market outlook"
                     :toc-item toc-item?})
   (column/column
    (card/card
     title
     (text-content/rich-content (:rich-content market-outlook))))))

(defn market-outlook-pages
  [report-data]
  (let [{:keys [market-outlook market-outlook-2]} report-data]
    (->> [market-outlook market-outlook-2]
         (filter rich-text-present?)
         (map-indexed
          (fn [idx section]
            (market-outlook-page report-data
                                 section
                                 (when (zero? idx) "Market outlook")
                                 (zero? idx)))))))

(defn credit-pages
  [report-data]
  (concat
   [(page/toc-page {:cover-image :front-page-image
                    :report-data report-data})]
   ;; TODO: The Credit Excel's tearsheet sheet contains less data than Buyout Excels'. Is this intentional? If so, how does it affect the layout of the pdf?
   [(pe-view-tearsheet/tearsheet-page report-data)]
   (pe-view-overview/overview-pages report-data)
   (esg-pages report-data)
   (pe-view-details-and-figures/details-and-figures-pages report-data)
   (pe-view-investors/investors-pages report-data)
   (capital-account-since-inception-pages report-data)
   (capital-account-year-to-date-pages report-data)
   (fees-and-carried-interest-pages report-data)))

(defn credit-pages-v3
  [report-data]
  (concat
   [(page/toc-page {:cover-image :front-page-image
                    :report-data report-data})]
   [(pe-view-tearsheet/tearsheet-page report-data)]
   (pe-view-overview/overview-pages report-data)
   (market-outlook-pages report-data)
   (esg-pages report-data)
   (pe-view-details-and-figures/details-and-figures-pages report-data)
   (pe-view-investors/investors-pages report-data)
   (capital-account-since-inception-pages report-data)
   (capital-account-year-to-date-pages report-data)
   (fees-and-carried-interest-pages report-data)))
